import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getCompaniesIsPosting, getCompaniesPostError } from '@selectors/companies';

import usePrevious from '@hooks/usePrevious';

import ConfirmModal from '@components/modal/ConfirmModal';
import ErrorModal from '@components/modal/ErrorModal';

const CompanySinglePendingUpdateModal: React.FC<ModalProps> = ({
    visible,
    handleClose,
    handleSubmit,
}) => {
    const [showError, setShowError] = useState(false);
    const isPosting = useSelector(getCompaniesIsPosting);
    const postError = useSelector(getCompaniesPostError);
    const prevProps = usePrevious({ postError });

    useEffect(() => {
        if (postError && !prevProps.postError && visible) {
            setShowError(true);
        }
    }, [postError, prevProps.postError, visible]);

    if (!visible) return null;

    if (showError)
        return <ErrorModal description={postError || undefined} closeModal={closeError} />;

    return (
        <ConfirmModal
            description="Are you sure you would like to update this entry?"
            isPosting={isPosting}
            handleSubmit={handleSubmit}
            closeModal={handleClose}
        />
    );

    function closeError(): void {
        setShowError(false);
        handleClose();
    }
};

interface ModalProps {
    visible: boolean;
    handleClose: () => void;
    handleSubmit: () => void;
}

export default CompanySinglePendingUpdateModal;
